import React from 'react'
import experience from './data/experience.json'
import "./Experience.css";

const Experience = () => {
  return (
    
    
    <div className="container ex" id='experiance'>
      <h1 id="mainHead">Training</h1>
      {
        experience.map((data)=>{
          return(
            
            <div key={data.id} className='ex-items '
             data-aos="zoom-in"
             data-aos-duration="1000"
            >
              <div className='left'>
                <img src={`/assets//${data.imageSrc}`} alt=''/>
              </div>
              <div className='center'>
                <h2>{data.role}</h2>
                <h4>
                  <span style={{color: "yellowgreen"}}>
                  {data.startDate} {data.endDate} {""}
                  </span>{""}
                  <span style={{color:'yellow'}}>
                    {data.location}
                  </span>
                </h4>
                <h5 style={{color:'yellow'}}>{data.experiences[0]}</h5>
                <h5 style={{color:'yellow'}}>{data.experiences[1]}</h5>
              </div>
            </div>
            
          )
        })
      }
      </div>
  )
}

export default Experience